export const load_webfont = (fontFamily) => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${fontFamily}`;
  document.head.appendChild(link);
}
